/**
 * SkillAutocomplete の react-hook-form (FormProvider) 統合ラッパー
 */
import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { SkillAutocomplete } from "../../SkillAutocomplete";

type SkillAutocompleteFieldProps = {
  registerName: string;
  placeholder?: string;
};

/**
 * react-hook-form の Controller で SkillAutocomplete を接続するフィールド
 * @param {SkillAutocompleteFieldProps} props コンポーネントProps
 * @return {JSX.Element} フォームフィールド
 */
export const SkillAutocompleteField: FC<SkillAutocompleteFieldProps> = ({
  registerName,
  placeholder,
}) => {
  const { control, setValue } = useFormContext();

  return (
    <Controller
      name={registerName}
      control={control}
      render={({ field }) => {
        const selectedSkills: string[] = field.value || [];
        return (
          <SkillAutocomplete
            selectedSkills={selectedSkills}
            onAddSkill={(skill: string) => {
              if (!selectedSkills.includes(skill)) {
                setValue(registerName, [...selectedSkills, skill]);
              }
            }}
            onRemoveSkill={(skill: string) => {
              setValue(
                registerName,
                selectedSkills.filter(s => s !== skill),
              );
            }}
            placeholder={placeholder}
          />
        );
      }}
    />
  );
};
